import React from 'react';
import {z} from 'zod';

import {AccountCircleOutlined} from '@mui/icons-material';

import {Avatar,AvatarPropsSchema} from './Avatar';
import AvatarSidebarPanel from './AvatarSidebarPanel';

export type AvatarProps = z.infer<typeof AvatarPropsSchema>;

export default{
    label: 'Avatar',
    icon: <AccountCircleOutlined />,
    type: 'Avatar',
    defaultData: {
        props: {
            imageUrl: 'https://ui-avatars.com/api/?size=128',
            alt: '',
            shape: 'circle',
            size: 64,
        },
        style: { padding: { top: 16, bottom: 16, left: 24, right: 24 } },
    },
    SidebarPanel: AvatarSidebarPanel,
    Component: Avatar,
    schema: AvatarPropsSchema,
};